import _ from 'lodash';

import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';


const LoadingActions = {

    start (type, id, extra) {
        AppDispatcher.dispatch(Object.assign({
            type, id,
            actionType: ActionTypes.LOADING_STARTED
        }, extra));
    },

    fail (type, id, extra) {
        AppDispatcher.dispatch(Object.assign({
            type, id,
            actionType: ActionTypes.LOADING_FAILED
        }, extra));
    },

    success (type, id, extra) {
        AppDispatcher.dispatch(Object.assign({
            type, id,
            actionType: ActionTypes.LOADING_COMPLETED
        }, extra));
    },

    /**
     * Wrap a async function so that it fires start, success and fail
     * loading events
     */
    wrap (type) {
        const self = this;
        return function (fn) {
            return async function (...args) {
                const id = _.uniqueId(type + '-');
                self.start(type, id);
                try {
                    const result = await fn.apply(this, args);
                    self.success(type, id, { result });
                    return result;
                } catch (error) {
                    self.fail(type, id, { error });
                    throw error;
                }
            };
        };
    }

};

export default LoadingActions;



// WEBPACK FOOTER //
// ./src/actions/LoadingActions.js